import { Box } from '@hivebrite/design-system/Box';

import type { RenderProps } from 'hb-builder/components/common/type/RenderProps';
import { Wrapper } from 'hb-builder/components/common/Wrapper/WrapperRender';
import { useRendererContext } from 'hb-builder/hooks';
import type { RenderComponent } from 'hb-builder/types';
import type { DocumentItem } from 'hb-react/backoffice/types/builder/builderDocument';
import type { SpacerItemAttributes } from 'hb-react/backoffice/types/builder/itemAttributes/spacerItemAttributes';

const componentType = 'single';

const Spacer: RenderComponent = () => {
  // This is intentional
};

const Render = ({ item }: RenderProps<DocumentItem<SpacerItemAttributes>>) => {
  const { isMobilePreview } = useRendererContext();

  if (!item) {
    return null;
  }
  const { attributes } = item;

  return (
    /* @ts-expect-error untyped */
    <Wrapper
      attributes={attributes}
      componentType={componentType}
      isMobilePreview={isMobilePreview}
    >
      <Box
        data-testid="builder-component-spacer"
        width="100%"
        height={attributes?.spacerHeight}
      />
    </Wrapper>
  );
};

Spacer.componentName = 'Spacer';
Spacer.Render = Render;

export default Spacer;
